import { SerializationHelper } from './serialization.helper';
import {
    User
} from '../models';

const USER_KEY = 'currentUser';
const LAST_ACTIVITY_KEY = 'lastActivityTime';

const maxLastTime = 90 * 24 * 60 * 60 * 1000 // 90 days


export class StoreHelper {

    static isActive(): boolean {
        if (localStorage.getItem(LAST_ACTIVITY_KEY) != null) {
            if (new Date().getTime() - parseFloat(localStorage.getItem(LAST_ACTIVITY_KEY)) < maxLastTime) {
                this.setActive();
                return true;
            }
        }
        return false;
    }

    static setActive() {
        localStorage.setItem(LAST_ACTIVITY_KEY, '' + new Date().getTime());
    }

    static getCurrentUser(): User {
        return localStorage.getItem(USER_KEY) != null
            ? SerializationHelper.toInstance(new User(), localStorage.getItem(USER_KEY))
            : null;
    }

    static setCurrentUser(user: User) {
        localStorage.setItem(USER_KEY, JSON.stringify(user));
        this.setActive();
    }

    static clearUser() {
        localStorage.removeItem(USER_KEY);
        localStorage.removeItem(LAST_ACTIVITY_KEY);
        // Cleans up a leftover 'email' entry from before HEM-1896, which is no
        // longer written but may still be sitting in a returning browser.
        localStorage.removeItem('email');
    }

  static getObject(key) {
        return localStorage.getItem(key) != null
            ? JSON.parse(localStorage.getItem(key))
            : null;
    }

    static setObject(key, value) {
        localStorage.setItem(key, JSON.stringify(value));
    }

    static removeObject(key) {
        localStorage.removeItem(key);
    }
}

